import { define } from 'wicked-elements'
import { register, deregister } from 'tiny-pulsar'
import { bus } from '../lib/eventBus'

define('[data-component="past-the-fold"]', {
  init() {
    this.handleScroll = this.handleScroll.bind(this)
    this.hasHalfFold = false
    this.hasFullFold = false
    this.namespace = `past-the-fold-${Math.random().toString(36).substr(2, 9)}`
  },
  connected() {
    register(this.namespace, this.handleScroll)
  },  
  disconnected() {
    deregister(this.namespace)
  },
  handleScroll() {
    const fold = window.innerHeight
    const halfFold = window.innerHeight / 2
    const scrollY = window.scrollY
    
    // Only update half-fold class if state needs to change
    const shouldHaveHalfFold = scrollY > halfFold
    if (shouldHaveHalfFold !== this.hasHalfFold) {
      this.hasHalfFold = shouldHaveHalfFold
      this.element.classList.toggle('fold-50', shouldHaveHalfFold)
      bus.emit('fold-50', shouldHaveHalfFold)
    }

    // Only update full-fold class if state needs to change
    const shouldHaveFullFold = scrollY > fold
    if (shouldHaveFullFold !== this.hasFullFold) {
      this.hasFullFold = shouldHaveFullFold
      this.element.classList.toggle('fold-100', shouldHaveFullFold)
      bus.emit('fold-100', shouldHaveFullFold)
    }
  },
});